import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

const Authentication = () => import('./views/Authentication.vue');
const ManageDevices = () => import('./views/ManageDevices.vue');
const DataStream = () => import('./views/DataStream.vue');
const FilterMessages = () => import('./views/FilterMessages.vue');
const Device = () => import('./views/Device.vue');
const ManageGroup = () => import('./views/ManageGroup/ManageGroup.vue');
const GroupUsers = () => import('./views/ManageGroup/GroupUsers.vue');
const GroupDevices = () => import('./views/ManageGroup/GroupDevices.vue');
const GroupList = () => import('./views/ManageGroup/GroupList.vue');
const GroupAddUser = () => import('./views/ManageGroup/GroupAddUser.vue');
const GroupAddDevice = () => import('./views/ManageGroup/GroupAddDevice.vue');
const GroupAddGroup = () => import('./views/ManageGroup/GroupAddGroup.vue');
const File = () => import('./views/File.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'authentication',
      component: Authentication,
    },
    {
      path: '/manageDevices',
      name: 'manageDevices',
      component: ManageDevices,
    },
    {
      path: '/dataStream',
      name: 'dataStream',
      component: DataStream,
    },
    {
      path: '/filterMessages',
      name: 'filterMessages',
      component: FilterMessages,
    },
    {
      path: '/device/:id',
      name: 'device',
      component: Device,
    },
    {
      path: '/file/:id',
      name: 'file',
      component: File,
    },
    {
      path: '/group/:id',
      name: 'group',
      component: ManageGroup,
      children: [
        {
          path: '',
          redirect: 'users',
        },
        {
          path: 'users',
          component: GroupUsers,
        },
        {
          path: 'devices',
          component: GroupDevices,
        },
        {
          path: 'groups',
          component: GroupList,
        },
        {
          path: 'users/add',
          component: GroupAddUser,
        },
        {
          path: 'devices/add',
          component: GroupAddDevice,
        },
        {
          path: 'groups/add',
          component: GroupAddGroup,
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/' && !store.getters['auth/authenticated']) {
    next(`/?redirect=${to.path}`);
  } else {
    next();
  }
});

export default router;